import React from "react";
import {Route, Routes} from "react-router-dom";
import CreateEquipment from "../container/equipment/CreateEquipment";
import EquipmentDetail from "../container/equipment/EquipmentDetail";
import EquipmentList from "../container/equipment/EquipmentList";
import UpdateEquipment from "../container/equipment/UpdateEquipment";
import ReliabilityList from "../container/equipment/ReliabilityList";

const Equipment = () => {
  return (
    <Routes>
      <Route path="/*" element={<EquipmentList />} />
      <Route path="Detail/:id" element={<EquipmentDetail />} />
      <Route path="Create" element={<CreateEquipment />} />
      <Route path="Edit/:id" element={<UpdateEquipment />} />
      <Route path="Reliability" element={<ReliabilityList />} />
    </Routes>
  );
};

export default Equipment;
